/**
 * Tab 도메인 Query Hook Wrapper
 */

import {useInfiniteQuery, useQuery} from '@tanstack/react-query';
import {TAB_QUERY_KEY_MAP} from '../api/tab/constant';
import {tabFactory} from '../factory/tabFactory';

// ============================================
// useDayOfWeekLayoutQuery
// ============================================

export function useDayOfWeekLayoutQuery(
  ...args: Parameters<typeof tabFactory.dayOfWeekLayout>
) {
  return useQuery(tabFactory.dayOfWeekLayout(...args));
}

useDayOfWeekLayoutQuery.getKey = (
  ...args: Parameters<typeof TAB_QUERY_KEY_MAP.dayOfWeekLayout>
) => [...TAB_QUERY_KEY_MAP.dayOfWeekLayout(...args)];

// ============================================
// useDayOfWeekListQuery
// ============================================

export function useDayOfWeekListQuery(
  ...args: Parameters<typeof tabFactory.dayOfWeekList>
) {
  return useQuery(tabFactory.dayOfWeekList(...args));
}

useDayOfWeekListQuery.getKey = (
  ...args: Parameters<typeof TAB_QUERY_KEY_MAP.dayOfWeekList>
) => [...TAB_QUERY_KEY_MAP.dayOfWeekList(...args)];

// ============================================
// useInfiniteDayOfWeekListQuery
// ============================================

export function useInfiniteDayOfWeekListQuery(
  ...args: Parameters<typeof tabFactory.infiniteDayOfWeekList>
) {
  return useInfiniteQuery(tabFactory.infiniteDayOfWeekList(...args));
}

useInfiniteDayOfWeekListQuery.getKey = (
  ...args: Parameters<typeof TAB_QUERY_KEY_MAP.infiniteDayOfWeekList>
) => [...TAB_QUERY_KEY_MAP.infiniteDayOfWeekList(...args)];
